<template>
    <div v-if="showPrice">
        <span
            :class="{'bold': emphasize}"
            v-html="label"
        />
        <span
            :class="['float-right', 'big-font', { 'text-faded': anyChanges }]"
        >

            <small v-if="!emphasize">
                <span
                    :class="{'bold': emphasize}"
                    v-html="price"
                />
                <span v-html="paymentPeriodLabel" />
            </small>
            <span v-else>
                <span
                    :class="{'bold': emphasize}"
                    v-html="price"
                />
                <span v-html="paymentPeriodLabel" />
            </span>
        </span>
    </div>
</template>
<script>
export default {
    name: 'PriceLine',
    props: {
        anyChanges: {
            type: Boolean,
            default() {
                return false;
            },
            requried: true

        },
        showPrice: {
            type: Boolean,
            default() {
                return true;
            },
            requried: true

        },
        price: {
            type: String,
            default() {
                return '';
            },
            requried: true
        },
        label: {
            type: String,
            default() {
                return '';
            },
            requried: true
        },
        paymentPeriodLabel: {
            type: String,
            default() {
                return '';
            }

        },
        emphasize: {
            type: Boolean,
            default() {
                return false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.big-font {
    font-size: rem-calc(20px);
    font-weight: bold;
    line-height: rem-calc(20px);
}

.bold {
    font-weight: bold;
}

</style>
